import {useMemo} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {parseSearch} from "@pg-mono/request";
import {Country} from "@pg-rp/common-types";

import {IRPStore} from "../../app/rp_reducer";
import {OfferDisplayType} from "../helpers/OfferDisplayType";
import {DEFAULT_DISTANCE} from "../list/constants/offer_list";
import {getFetchOfferListSubFilterQuery} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {OfferType} from "../types/OfferType";
import {transformOfferFetchQuery} from "../utils/transform_offer_fetch_query";
import {useParseFriendlyUrl} from "./use_parse_friendly_url";

export interface IUseMapOfferListQueryResult {
    query: Record<string, unknown> | null;
    baseQuery: Record<string, unknown> | null;
    isLoading: boolean;
    error: unknown;
}

const offerListConstraints = {
    limited_presentation: false,
    display_type: [OfferDisplayType.FOR_SALE],
    for_sale: true,
    show_on_listing: true
};

export const useMapOfferListQuery = (): IUseMapOfferListQueryResult => {
    const location = useLocation();
    const routeQuery = useMemo<Record<string, string | string[] | null> | null>(() => {
        const parsed = parseSearch(location.search);
        if (!parsed || Object.keys(parsed).length === 0) {
            return null;
        }

        return parsed;
    }, [location.search]);

    const {query: friendlyUrlQuery, isLoading, error, urlParams} = useParseFriendlyUrl();

    // In some cases distance isn't correctly sync with URL, and value is only set in the Redux form state.
    // In those cases we need to get distance from Redux form state as fallback
    // TODO: probably to handle this correctly we need to make URL as source of truth (need SEO acceptance)
    const distanceFromForm = useSelector((state: IRPStore) => state.search?.formValues?.distance);

    const baseQuery = useMemo(() => {
        if (!friendlyUrlQuery && !routeQuery) {
            return null;
        }

        if (friendlyUrlQuery && routeQuery) {
            return {
                ...friendlyUrlQuery,
                ...routeQuery
            };
        }

        return friendlyUrlQuery ?? routeQuery ?? null;
    }, [friendlyUrlQuery, routeQuery]);

    const fullQuery = useMemo(() => {
        if (!baseQuery) {
            return null;
        }

        const processedQuery = getFetchOfferListSubFilterQuery({...baseQuery}, urlParams.offerListSubType, urlParams.offerListSubFilter);
        const safeQuery = omit(processedQuery, ["s"]);
        const transformedQuery = transformOfferFetchQuery(safeQuery);
        const finalCountry = processedQuery.country || Country.POLAND;

        return {
            distance: "distance" in baseQuery && !!baseQuery.distance ? Number(baseQuery.distance) : (distanceFromForm ?? DEFAULT_DISTANCE),
            ...transformedQuery,
            ...(!safeQuery.type ? {type: [OfferType.FLAT, OfferType.HOUSE]} : {}),
            ...offerListConstraints,
            ...(finalCountry ? {country: finalCountry} : {}),
            page_size: 0
        };
    }, [baseQuery, urlParams.offerListSubType, urlParams.offerListSubFilter, distanceFromForm]);

    return {
        query: fullQuery,
        baseQuery,
        isLoading,
        error
    };
};
import {useMemo} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {parseSearch} from "@pg-mono/request";
import {Country} from "@pg-rp/common-types";

import {IRPStore} from "../../app/rp_reducer";
import {OfferDisplayType} from "../helpers/OfferDisplayType";
import {DEFAULT_DISTANCE} from "../list/constants/offer_list";
import {getFetchOfferListSubFilterQuery} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {OfferType} from "../types/OfferType";
import {transformOfferFetchQuery} from "../utils/transform_offer_fetch_query";
import {useParseFriendlyUrl} from "./use_parse_friendly_url";

export interface IUseMapOfferListQueryResult {
    query: Record<string, unknown> | null;
    baseQuery: Record<string, unknown> | null;
    isLoading: boolean;
    error: unknown;
}

const offerListConstraints = {
    limited_presentation: false,
    display_type: [OfferDisplayType.FOR_SALE],
    for_sale: true,
    show_on_listing: true
};

export const useMapOfferListQuery = (): IUseMapOfferListQueryResult => {
    const location = useLocation();
    const routeQuery = useMemo<Record<string, string | string[] | null> | null>(() => {
        const parsed = parseSearch(location.search);
        if (!parsed || Object.keys(parsed).length === 0) {
            return null;
        }

        return parsed;
    }, [location.search]);

    const {query: friendlyUrlQuery, isLoading, error, urlParams} = useParseFriendlyUrl();

    // In some cases distance isn't correctly sync with URL, and value is only set in the Redux form state.
    // In those cases we need to get distance from Redux form state as fallback
    // TODO: probably to handle this correctly we need to make URL as source of truth (need SEO acceptance)
    const distanceFromForm = useSelector((state: IRPStore) => state.search?.formValues?.distance);

    const baseQuery = useMemo(() => {
        if (!friendlyUrlQuery && !routeQuery) {
            return null;
        }

        if (friendlyUrlQuery && routeQuery) {
            return {
                ...friendlyUrlQuery,
                ...routeQuery
            };
        }

        return friendlyUrlQuery ?? routeQuery ?? null;
    }, [friendlyUrlQuery, routeQuery]);

    const fullQuery = useMemo(() => {
        if (!baseQuery) {
            return null;
        }

        const processedQuery = getFetchOfferListSubFilterQuery({...baseQuery}, urlParams.offerListSubType, urlParams.offerListSubFilter);
        const safeQuery = omit(processedQuery, ["s"]);
        const transformedQuery = transformOfferFetchQuery(safeQuery);
        const finalCountry = processedQuery.country || Country.POLAND;

        return {
            distance: "distance" in baseQuery && !!baseQuery.distance ? Number(baseQuery.distance) : (distanceFromForm ?? DEFAULT_DISTANCE),
            ...transformedQuery,
            ...(!safeQuery.type ? {type: [OfferType.FLAT, OfferType.HOUSE]} : {}),
            ...offerListConstraints,
            ...(finalCountry ? {country: finalCountry} : {}),
            page_size: 0
        };
    }, [baseQuery, urlParams.offerListSubType, urlParams.offerListSubFilter, distanceFromForm]);

    return {
        query: fullQuery,
        baseQuery,
        isLoading,
        error
    };
};
